import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { LinkButton } from '~/features/navigation'
import { HighlightV3Mutators } from '~/mutators/highlights-v3'
import { useTRPC } from '~/services/trpc'

import { HighlightForm, highlightToFormValues } from './-components/form'
import { HighlightPaneShell } from './-components/highlight-pane'

export const Route = createFileRoute(
  '/_authenticated/$alias/_app/highlights/$highlightCategoryId/edit/$highlightId',
)({
  component: RouteComponent,
  loader: async ({ context: { trpc, queryClient }, params }) => {
    await Promise.all([
      queryClient.ensureQueryData(
        trpc.highlightCategoriesV3.getById.queryOptions(
          params.highlightCategoryId,
        ),
      ),
      queryClient.ensureQueryData(
        trpc.highlightsV3.getById.queryOptions(params.highlightId),
      ),
    ])
    return
  },
})

function RouteComponent() {
  const params = Route.useParams()
  const navigate = Route.useNavigate()
  const trpc = useTRPC()
  const { data: category } = useQuery(
    trpc.highlightCategoriesV3.getById.queryOptions(params.highlightCategoryId),
  )
  const { data: highlight } = useQuery(
    trpc.highlightsV3.getById.queryOptions(params.highlightId),
  )
  const { update } = HighlightV3Mutators.useUpdate({
    onSuccess: () => {
      void navigate({
        to: '/$alias/highlights',
        params,
      })
    },
  })

  if (!highlight) return null

  return (
    <HighlightPaneShell
      alias={params.alias}
      title={highlight.name || 'Edit highlight'}
      description={
        category
          ? `Update this highlight in ${category.name}.`
          : 'Update this highlight.'
      }
    >
        <HighlightForm
          defaultValues={highlightToFormValues(highlight)}
          excludeHighlightIds={[params.highlightId]}
          submitLabel="Save highlight"
          cancelAction={
            <LinkButton
              to="/$alias/highlights"
              from={Route.fullPath}
              params={{ alias: params.alias }}
              variant="secondary"
            >
              Cancel
            </LinkButton>
          }
          onSubmit={async (values) => {
            await update({
              id: params.highlightId,
              ...values,
              categoryId: params.highlightCategoryId,
            })
          }}
        />
    </HighlightPaneShell>
  )
}
